// extracted by mini-css-extract-plugin
export default {"image":"NW-z","loaded":"OW-z"};